import { atom, useAtomValue, useSetAtom } from 'jotai';

const sideRightDisplay = atom(true);

export const useSideRightDisplay = () => useAtomValue(sideRightDisplay);
export const useSetSideRightDisplay = () => useSetAtom(sideRightDisplay);
